module.exports = __webpack_public_path__ + "img/sun_3427d7e7d.png";